import { HTTPError, sendHTTPRequest } from '@/util/http.ts'
import { goalbookUrls } from '@/util/links.js'
import type {
  CuratedCollection,
  CuratedCollectionDetail,
  CuratedCollectionResponse,
  CuratedCollectionsResponse
} from '@/curated_collections/curated_collection_types.ts'

const CURATED_COLLECTIONS_URL = `${goalbookUrls.pathwaysApi}/collections/curated`

export async function getAllCuratedCollections(queryParams: Record<string, string> = {}): Promise<CuratedCollection[]> {
  try {
    const response = await sendHTTPRequest({
      url: CURATED_COLLECTIONS_URL,
      method: 'GET',
      urlParams: queryParams,
      includeCredentials: true
    })
    const payload = await response.json() as CuratedCollectionsResponse
    return payload.collections
  } catch (e) {
    throw new Error('Failed to get curated collections', { cause: e })
  }
}

async function failureMessage(error: unknown) {
  const responseText = error instanceof HTTPError ? await error.response.text() : ''
  return responseText || 'Failed to get curated collection'
}

/** Rejects with the service's own response text, which the collection page shows the user to pass on to support. */
export async function getCuratedCollection(id: string, userUuid: string): Promise<CuratedCollectionDetail> {
  try {
    const response = await sendHTTPRequest({
      url: `${CURATED_COLLECTIONS_URL}/${encodeURIComponent(id)}`,
      method: 'GET',
      urlParams: { user_uuid: userUuid },
      includeCredentials: true
    })
    const payload = await response.json() as CuratedCollectionResponse
    return payload.collection
  } catch (e) {
    throw new Error(await failureMessage(e), { cause: e })
  }
}
